import { render, staticRenderFns } from "./babyTicketAppraise.vue?vue&type=template&id=108c909b&scoped=true&"
import script from "./babyTicketAppraise.vue?vue&type=script&lang=js&"
export * from "./babyTicketAppraise.vue?vue&type=script&lang=js&"
import style0 from "./babyTicketAppraise.vue?vue&type=style&index=0&id=108c909b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108c909b",
  null
  
)

export default component.exports